"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = siteSaga;
var _effects = require("redux-saga/effects");
var _site = require("./site.action");
var _site2 = require("./site.constant");
var _services = require("../../../../services");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(siteSaga);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; } // @flow
/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add.
 */
function siteAdd(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _response$data, response, _response$data2;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.siteAddApi, payload);
        case 3:
          response = _context.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) === 201)) {
            _context.next = 9;
            break;
          }
          _context.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.ADD, response.data.data));
        case 7:
          _context.next = 11;
          break;
        case 9:
          _context.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.ADD, response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.data));
        case 11:
          _context.next = 17;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          _context.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.ADD, _context.t0));
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  })();
}

/**
 * edit save
 * @param payload
 * @returns api response
 * @description this function used to edit save.
 */
function siteEditSave(_ref2) {
  var payload = _ref2.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _response$data3, response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.siteEditSaveApi, payload);
        case 3:
          response = _context2.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.code) === 202)) {
            _context2.next = 9;
            break;
          }
          _context2.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.EDIT_SAVE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context2.next = 11;
          break;
        case 9:
          _context2.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.EDIT_SAVE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context2.next = 17;
          break;
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.EDIT_SAVE, _context2.t0));
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 13]]);
  })();
}

/**
 * edit
 * @param payload
 * @returns api response
 * @description this function used to edit.
 */
function siteEdit(_ref3) {
  var payload = _ref3.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _response$data4, response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.siteEditApi, payload);
        case 3:
          response = _context3.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.code) === 200)) {
            _context3.next = 9;
            break;
          }
          _context3.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.EDIT, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context3.next = 11;
          break;
        case 9:
          _context3.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.EDIT, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context3.next = 17;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.EDIT, _context3.t0));
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 13]]);
  })();
}

/**
 * read
 * @param payload
 * @returns api response
 * @description this function used to edit.
 */
function siteRead(_ref4) {
  var payload = _ref4.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _response$data5, response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.siteReadApi, payload);
        case 3:
          response = _context4.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.code) === 200)) {
            _context4.next = 9;
            break;
          }
          _context4.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.READ, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context4.next = 11;
          break;
        case 9:
          _context4.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.READ, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context4.next = 17;
          break;
        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.READ, _context4.t0));
        case 17:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 13]]);
  })();
}

/**
 * change
 * @param payload
 * @returns api response
 * @description this function used to change.
 */
function siteChange(_ref5) {
  var payload = _ref5.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _response$data6, response;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.siteChangeApi, payload);
        case 3:
          response = _context5.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.code) === 202)) {
            _context5.next = 9;
            break;
          }
          _context5.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.CHANGE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context5.next = 11;
          break;
        case 9:
          _context5.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.CHANGE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context5.next = 17;
          break;
        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.CHANGE, _context5.t0));
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 13]]);
  })();
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update.
 */
function siteUpdate(_ref6) {
  var payload = _ref6.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var _response$data7, response, _response$data8;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.siteUpdateApi, payload);
        case 3:
          response = _context6.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.code) === 202)) {
            _context6.next = 9;
            break;
          }
          _context6.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.UPDATE, response.data.data));
        case 7:
          _context6.next = 11;
          break;
        case 9:
          _context6.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.UPDATE, response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.data));
        case 11:
          _context6.next = 17;
          break;
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.UPDATE, _context6.t0));
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 13]]);
  })();
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to list.
 */
function siteList(_ref7) {
  var payload = _ref7.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var _payload, _payload$fkUserIdList, _payload2, _payload2$fkUserIdLis, _payload3, _payload4, _payload5, _payload5$colApproved, _payload7, _payload7$colIsEdited, _payload9, _payload9$colIsActive, _payload10, _payload11, _payload11$tags, _response$data9, _response$data10, filter, _payload6, approvedAdmin, _payload8, isEditedCase, _payload12, _payload12$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          filter = {}; // Owner
          if ((_payload = payload) !== null && _payload !== void 0 && (_payload$fkUserIdList = _payload.fkUserIdList) !== null && _payload$fkUserIdList !== void 0 && _payload$fkUserIdList.value) filter["fkUserIdList"] = (_payload2 = payload) === null || _payload2 === void 0 ? void 0 : (_payload2$fkUserIdLis = _payload2.fkUserIdList) === null || _payload2$fkUserIdLis === void 0 ? void 0 : _payload2$fkUserIdLis.value;else if (Array.isArray((_payload3 = payload) === null || _payload3 === void 0 ? void 0 : _payload3.fkUserIdList)) filter["fkUserIdList"] = (_payload4 = payload) === null || _payload4 === void 0 ? void 0 : _payload4.fkUserIdList;

          // Approved

          if (((_payload5 = payload) === null || _payload5 === void 0 ? void 0 : (_payload5$colApproved = _payload5.colApprovedByAdmin) === null || _payload5$colApproved === void 0 ? void 0 : _payload5$colApproved.length) > 0) {
            approvedAdmin = (_payload6 = payload) === null || _payload6 === void 0 ? void 0 : _payload6.colApprovedByAdmin;
            approvedAdmin.map(function (item) {
              switch (item) {
                case "isSubmited":
                  filter["submit"] = true;
                  break;
                case true:
                  filter["approved"] = true;
                  break;
                default:
                  filter["pending"] = true;
              }
            });
          }

          // Edit
          if (((_payload7 = payload) === null || _payload7 === void 0 ? void 0 : (_payload7$colIsEdited = _payload7.colIsEdited) === null || _payload7$colIsEdited === void 0 ? void 0 : _payload7$colIsEdited.length) > 0) {
            isEditedCase = (_payload8 = payload) === null || _payload8 === void 0 ? void 0 : _payload8.colIsEdited;
            isEditedCase.map(function (item) {
              switch (item) {
                case "colIsLocked":
                  filter["locked"] = true;
                  break;
                case true:
                  filter["edited"] = true;
                  break;
                default:
                  filter["unedited"] = true;
              }
            });
          }

          // Status
          if (((_payload9 = payload) === null || _payload9 === void 0 ? void 0 : (_payload9$colIsActive = _payload9.colIsActive) === null || _payload9$colIsActive === void 0 ? void 0 : _payload9$colIsActive.length) === 1) filter["colIsActive"] = (_payload10 = payload) === null || _payload10 === void 0 ? void 0 : _payload10.colIsActive[0];
          if (((_payload11 = payload) === null || _payload11 === void 0 ? void 0 : (_payload11$tags = _payload11.tags) === null || _payload11$tags === void 0 ? void 0 : _payload11$tags.length) > 0) {
            colTags = "";
            (_payload12 = payload) === null || _payload12 === void 0 ? void 0 : (_payload12$tags = _payload12.tags) === null || _payload12$tags === void 0 ? void 0 : _payload12$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          delete payload.fkUserIdList;
          delete payload.colApprovedByAdmin;
          delete payload.colIsEdited;
          delete payload.colIsActive;
          delete payload.tags;
          delete payload.colTags;
          payload = _objectSpread(_objectSpread({}, filter), payload);
          _context7.next = 16;
          return (0, _effects.call)(_services.siteListApi, payload);
        case 16:
          response = _context7.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.code) === 200)) {
            _context7.next = 22;
            break;
          }
          _context7.next = 20;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.LIST, response.data.data));
        case 20:
          _context7.next = 24;
          break;
        case 22:
          _context7.next = 24;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.LIST, response === null || response === void 0 ? void 0 : (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : _response$data10.data));
        case 24:
          _context7.next = 30;
          break;
        case 26:
          _context7.prev = 26;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 30;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.LIST, _context7.t0));
        case 30:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 26]]);
  })();
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to list.
 */
function siteListReviewAndApproval(_ref8) {
  var payload = _ref8.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var _payload13, _payload13$fkUserIdLi, _payload14, _payload14$fkUserIdLi, _payload15, _payload16, _payload17, _payload17$colApprove, _payload19, _payload19$colIsEdite, _payload21, _payload21$colIsActiv, _payload22, _payload23, _payload23$tags, _response$data11, _response$data12, filter, _payload18, approvedAdmin, _payload20, isEditedCase, _payload24, _payload24$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          filter = {}; // Owner
          if ((_payload13 = payload) !== null && _payload13 !== void 0 && (_payload13$fkUserIdLi = _payload13.fkUserIdList) !== null && _payload13$fkUserIdLi !== void 0 && _payload13$fkUserIdLi.value) filter["fkUserIdList"] = (_payload14 = payload) === null || _payload14 === void 0 ? void 0 : (_payload14$fkUserIdLi = _payload14.fkUserIdList) === null || _payload14$fkUserIdLi === void 0 ? void 0 : _payload14$fkUserIdLi.value;else if (Array.isArray((_payload15 = payload) === null || _payload15 === void 0 ? void 0 : _payload15.fkUserIdList)) filter["fkUserIdList"] = (_payload16 = payload) === null || _payload16 === void 0 ? void 0 : _payload16.fkUserIdList;

          // Approved

          if (((_payload17 = payload) === null || _payload17 === void 0 ? void 0 : (_payload17$colApprove = _payload17.colApprovedByAdmin) === null || _payload17$colApprove === void 0 ? void 0 : _payload17$colApprove.length) > 0) {
            approvedAdmin = (_payload18 = payload) === null || _payload18 === void 0 ? void 0 : _payload18.colApprovedByAdmin;
            approvedAdmin.map(function (item) {
              switch (item) {
                case "isSubmited":
                  filter["submit"] = true;
                  break;
                case true:
                  filter["approved"] = true;
                  break;
                default:
                  filter["reviewAndApproval"] = true;
              }
            });
          }

          // Edit
          if (((_payload19 = payload) === null || _payload19 === void 0 ? void 0 : (_payload19$colIsEdite = _payload19.colIsEdited) === null || _payload19$colIsEdite === void 0 ? void 0 : _payload19$colIsEdite.length) > 0) {
            isEditedCase = (_payload20 = payload) === null || _payload20 === void 0 ? void 0 : _payload20.colIsEdited;
            isEditedCase.map(function (item) {
              switch (item) {
                case "colIsLocked":
                  filter["locked"] = true;
                  break;
                case true:
                  filter["edited"] = true;
                  break;
                default:
                  filter["unedited"] = true;
              }
            });
          }

          // Status
          if (((_payload21 = payload) === null || _payload21 === void 0 ? void 0 : (_payload21$colIsActiv = _payload21.colIsActive) === null || _payload21$colIsActiv === void 0 ? void 0 : _payload21$colIsActiv.length) === 1) filter["colIsActive"] = (_payload22 = payload) === null || _payload22 === void 0 ? void 0 : _payload22.colIsActive[0];
          if (((_payload23 = payload) === null || _payload23 === void 0 ? void 0 : (_payload23$tags = _payload23.tags) === null || _payload23$tags === void 0 ? void 0 : _payload23$tags.length) > 0) {
            colTags = "";
            (_payload24 = payload) === null || _payload24 === void 0 ? void 0 : (_payload24$tags = _payload24.tags) === null || _payload24$tags === void 0 ? void 0 : _payload24$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          delete payload.fkUserIdList;
          delete payload.colApprovedByAdmin;
          delete payload.colIsEdited;
          delete payload.colIsActive;
          delete payload.tags;
          delete payload.colTags;
          payload = _objectSpread(_objectSpread({}, filter), payload);
          _context8.next = 16;
          return (0, _effects.call)(_services.siteListApi, payload);
        case 16:
          response = _context8.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : _response$data11.code) === 200)) {
            _context8.next = 22;
            break;
          }
          _context8.next = 20;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.LIST, response.data.data));
        case 20:
          _context8.next = 24;
          break;
        case 22:
          _context8.next = 24;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.LIST, response === null || response === void 0 ? void 0 : (_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : _response$data12.data));
        case 24:
          _context8.next = 30;
          break;
        case 26:
          _context8.prev = 26;
          _context8.t0 = _context8["catch"](0);
          _context8.next = 30;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.LIST, _context8.t0));
        case 30:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 26]]);
  })();
}

/**
 * submit
 * @param payload
 * @returns api response
 * @description this function used to submit.
 */
function siteSubmit(_ref9) {
  var payload = _ref9.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var _response$data13, response, _response$data14;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_services.siteSubmitApi, payload);
        case 3:
          response = _context9.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : _response$data13.code) === 202)) {
            _context9.next = 9;
            break;
          }
          _context9.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.SUBMIT, response.data.data));
        case 7:
          _context9.next = 11;
          break;
        case 9:
          _context9.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.SUBMIT, response === null || response === void 0 ? void 0 : (_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : _response$data14.data));
        case 11:
          _context9.next = 17;
          break;
        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9["catch"](0);
          _context9.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.SUBMIT, _context9.t0));
        case 17:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 13]]);
  })();
}

/**
 * bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to bulk hard delete.
 */
function siteApprove(_ref10) {
  var payload = _ref10.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var _response$data15, response, _response$data16;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_services.siteApproveApi, payload);
        case 3:
          response = _context10.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data15 = response.data) === null || _response$data15 === void 0 ? void 0 : _response$data15.code) === 202)) {
            _context10.next = 9;
            break;
          }
          _context10.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.APPROVE, response.data.data));
        case 7:
          _context10.next = 11;
          break;
        case 9:
          _context10.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.APPROVE, response === null || response === void 0 ? void 0 : (_response$data16 = response.data) === null || _response$data16 === void 0 ? void 0 : _response$data16.data));
        case 11:
          _context10.next = 17;
          break;
        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](0);
          _context10.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.APPROVE, _context10.t0));
        case 17:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 13]]);
  })();
}

/**
 * bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete.
 */
function siteDelete(_ref11) {
  var payload = _ref11.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var _response$data17, response, _response$data18;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return (0, _effects.call)(_services.siteDeleteApi, payload);
        case 3:
          response = _context11.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data17 = response.data) === null || _response$data17 === void 0 ? void 0 : _response$data17.code) === 202)) {
            _context11.next = 9;
            break;
          }
          _context11.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.DELETE, response.data.data));
        case 7:
          _context11.next = 11;
          break;
        case 9:
          _context11.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.DELETE, response === null || response === void 0 ? void 0 : (_response$data18 = response.data) === null || _response$data18 === void 0 ? void 0 : _response$data18.data));
        case 11:
          _context11.next = 17;
          break;
        case 13:
          _context11.prev = 13;
          _context11.t0 = _context11["catch"](0);
          _context11.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.DELETE, _context11.t0));
        case 17:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 13]]);
  })();
}

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore.
 */
function siteClone(_ref12) {
  var payload = _ref12.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var _response$data19, response, _response$data20;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_services.siteCloneApi, payload);
        case 3:
          response = _context12.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data19 = response.data) === null || _response$data19 === void 0 ? void 0 : _response$data19.code) === 202)) {
            _context12.next = 9;
            break;
          }
          _context12.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.CLONE, response.data.data));
        case 7:
          _context12.next = 11;
          break;
        case 9:
          _context12.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.CLONE, response === null || response === void 0 ? void 0 : (_response$data20 = response.data) === null || _response$data20 === void 0 ? void 0 : _response$data20.data));
        case 11:
          _context12.next = 17;
          break;
        case 13:
          _context12.prev = 13;
          _context12.t0 = _context12["catch"](0);
          _context12.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.CLONE, _context12.t0));
        case 17:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 13]]);
  })();
}

/**
 * bulk link
 * @param payload
 * @returns api response
 * @description this function used to bulk link.
 */
function siteSave(_ref13) {
  var payload = _ref13.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
    var _response$data21, response, _response$data22;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return (0, _effects.call)(_services.siteSaveApi, payload);
        case 3:
          response = _context13.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data21 = response.data) === null || _response$data21 === void 0 ? void 0 : _response$data21.code) === 202)) {
            _context13.next = 9;
            break;
          }
          _context13.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.SAVE, response.data.data));
        case 7:
          _context13.next = 11;
          break;
        case 9:
          _context13.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.SAVE, response === null || response === void 0 ? void 0 : (_response$data22 = response.data) === null || _response$data22 === void 0 ? void 0 : _response$data22.data));
        case 11:
          _context13.next = 17;
          break;
        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13["catch"](0);
          _context13.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.SAVE, _context13.t0));
        case 17:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 13]]);
  })();
}

/**
 * bulk link
 * @param payload
 * @returns api response
 * @description this function used to bulk link.
 */
function siteBuildList(_ref14) {
  var payload = _ref14.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
    var _response$data23, response, _response$data24;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return (0, _effects.call)(_services.siteBuildListApi, payload);
        case 3:
          response = _context14.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data23 = response.data) === null || _response$data23 === void 0 ? void 0 : _response$data23.code) === 200)) {
            _context14.next = 9;
            break;
          }
          _context14.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.BUILD_LIST, response.data.data));
        case 7:
          _context14.next = 11;
          break;
        case 9:
          _context14.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.BUILD_LIST, response === null || response === void 0 ? void 0 : (_response$data24 = response.data) === null || _response$data24 === void 0 ? void 0 : _response$data24.data));
        case 11:
          _context14.next = 17;
          break;
        case 13:
          _context14.prev = 13;
          _context14.t0 = _context14["catch"](0);
          _context14.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.BUILD_LIST, _context14.t0));
        case 17:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 13]]);
  })();
}

/**
 * filter
 * @param payload
 * @returns api response
 * @description this function used to filter.
 */
function siteFilter(_ref15) {
  var payload = _ref15.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
    var _response$data25, response, _response$data26;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return (0, _effects.call)(_services.siteFilterApi, payload);
        case 3:
          response = _context15.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data25 = response.data) === null || _response$data25 === void 0 ? void 0 : _response$data25.code) === 202)) {
            _context15.next = 9;
            break;
          }
          _context15.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.FILTER, response.data.data));
        case 7:
          _context15.next = 11;
          break;
        case 9:
          _context15.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.FILTER, response === null || response === void 0 ? void 0 : (_response$data26 = response.data) === null || _response$data26 === void 0 ? void 0 : _response$data26.data));
        case 11:
          _context15.next = 17;
          break;
        case 13:
          _context15.prev = 13;
          _context15.t0 = _context15["catch"](0);
          _context15.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.FILTER, _context15.t0));
        case 17:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[0, 13]]);
  })();
}

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause.
 */
function sitePause(_ref16) {
  var payload = _ref16.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
    var _response$data27, response, _response$data28;
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return (0, _effects.call)(_services.sitePauseApi, payload);
        case 3:
          response = _context16.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data27 = response.data) === null || _response$data27 === void 0 ? void 0 : _response$data27.code) === 202)) {
            _context16.next = 9;
            break;
          }
          _context16.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.PAUSE, response.data.data));
        case 7:
          _context16.next = 11;
          break;
        case 9:
          _context16.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.PAUSE, response === null || response === void 0 ? void 0 : (_response$data28 = response.data) === null || _response$data28 === void 0 ? void 0 : _response$data28.data));
        case 11:
          _context16.next = 17;
          break;
        case 13:
          _context16.prev = 13;
          _context16.t0 = _context16["catch"](0);
          _context16.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.PAUSE, _context16.t0));
        case 17:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[0, 13]]);
  })();
}

/**
 * play
 * @param payload
 * @returns api response
 * @description this function used to play.
 */
function sitePlay(_ref17) {
  var payload = _ref17.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
    var _response$data29, response, _response$data30;
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.prev = 0;
          _context17.next = 3;
          return (0, _effects.call)(_services.sitePlayApi, payload);
        case 3:
          response = _context17.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data29 = response.data) === null || _response$data29 === void 0 ? void 0 : _response$data29.code) === 202)) {
            _context17.next = 9;
            break;
          }
          _context17.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.PLAY, response.data.data));
        case 7:
          _context17.next = 11;
          break;
        case 9:
          _context17.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.PLAY, response === null || response === void 0 ? void 0 : (_response$data30 = response.data) === null || _response$data30 === void 0 ? void 0 : _response$data30.data));
        case 11:
          _context17.next = 17;
          break;
        case 13:
          _context17.prev = 13;
          _context17.t0 = _context17["catch"](0);
          _context17.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.PLAY, _context17.t0));
        case 17:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[0, 13]]);
  })();
}

/**
 * copy url
 * @param payload
 * @returns api response
 * @description this function used to copy url.
 */
function siteCopyUrl(_ref18) {
  var payload = _ref18.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
    var _response$data31, response, _response$data32;
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.prev = 0;
          _context18.next = 3;
          return (0, _effects.call)(_services.siteCopyUrlApi, payload);
        case 3:
          response = _context18.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data31 = response.data) === null || _response$data31 === void 0 ? void 0 : _response$data31.code) === 202)) {
            _context18.next = 9;
            break;
          }
          _context18.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.COPY_URL, response.data.data));
        case 7:
          _context18.next = 11;
          break;
        case 9:
          _context18.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.COPY_URL, response === null || response === void 0 ? void 0 : (_response$data32 = response.data) === null || _response$data32 === void 0 ? void 0 : _response$data32.data));
        case 11:
          _context18.next = 17;
          break;
        case 13:
          _context18.prev = 13;
          _context18.t0 = _context18["catch"](0);
          _context18.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.COPY_URL, _context18.t0));
        case 17:
        case "end":
          return _context18.stop();
      }
    }, _callee18, null, [[0, 13]]);
  })();
}

/**
 * download url
 * @param payload
 * @returns api response
 * @description this function used to download url.
 */
function siteDownloadUrl(_ref19) {
  var payload = _ref19.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
    var _response$data33, response, _response$data34;
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.prev = 0;
          _context19.next = 3;
          return (0, _effects.call)(_services.siteDownloadUrlApi, payload);
        case 3:
          response = _context19.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data33 = response.data) === null || _response$data33 === void 0 ? void 0 : _response$data33.code) === 202)) {
            _context19.next = 9;
            break;
          }
          _context19.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.DOWNLOAD_EMAIL, response.data.data));
        case 7:
          _context19.next = 11;
          break;
        case 9:
          _context19.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.DOWNLOAD_EMAIL, response === null || response === void 0 ? void 0 : (_response$data34 = response.data) === null || _response$data34 === void 0 ? void 0 : _response$data34.data));
        case 11:
          _context19.next = 17;
          break;
        case 13:
          _context19.prev = 13;
          _context19.t0 = _context19["catch"](0);
          _context19.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.DOWNLOAD_EMAIL, _context19.t0));
        case 17:
        case "end":
          return _context19.stop();
      }
    }, _callee19, null, [[0, 13]]);
  })();
}

/**
 * lock
 * @param payload
 * @returns api response
 * @description this function used to lock.
 */
function siteLock(_ref20) {
  var payload = _ref20.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
    var _response$data35, response, _response$data36;
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.prev = 0;
          _context20.next = 3;
          return (0, _effects.call)(_services.siteLockApi, payload);
        case 3:
          response = _context20.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data35 = response.data) === null || _response$data35 === void 0 ? void 0 : _response$data35.code) === 202)) {
            _context20.next = 9;
            break;
          }
          _context20.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.LOCK, response.data.data));
        case 7:
          _context20.next = 11;
          break;
        case 9:
          _context20.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.LOCK, response === null || response === void 0 ? void 0 : (_response$data36 = response.data) === null || _response$data36 === void 0 ? void 0 : _response$data36.data));
        case 11:
          _context20.next = 17;
          break;
        case 13:
          _context20.prev = 13;
          _context20.t0 = _context20["catch"](0);
          _context20.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.LOCK, _context20.t0));
        case 17:
        case "end":
          return _context20.stop();
      }
    }, _callee20, null, [[0, 13]]);
  })();
}

/**
 * lock
 * @param payload
 * @returns api response
 * @description this function used to lock.
 */
function siteEditorLock(_ref21) {
  var payload = _ref21.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
    var _response$data37, response;
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.prev = 0;
          _context21.next = 3;
          return (0, _effects.call)(_services.siteEditorLockApi, payload);
        case 3:
          response = _context21.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data37 = response.data) === null || _response$data37 === void 0 ? void 0 : _response$data37.code) === 200)) {
            _context21.next = 9;
            break;
          }
          _context21.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.EDITORLOCK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context21.next = 11;
          break;
        case 9:
          _context21.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.EDITORLOCK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context21.next = 17;
          break;
        case 13:
          _context21.prev = 13;
          _context21.t0 = _context21["catch"](0);
          _context21.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.EDITORLOCK, _context21.t0));
        case 17:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[0, 13]]);
  })();
}

/**
 * lock
 * @param payload
 * @returns api response
 * @description this function used to lock.
 */
function siteEditorUnlock(_ref22) {
  var payload = _ref22.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
    var _response$data38, _response$data39, response;
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.prev = 0;
          _context22.next = 3;
          return (0, _effects.call)(_services.siteEditorUnlockApi, payload);
        case 3:
          response = _context22.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data38 = response.data) === null || _response$data38 === void 0 ? void 0 : _response$data38.code) === 202 || (response === null || response === void 0 ? void 0 : (_response$data39 = response.data) === null || _response$data39 === void 0 ? void 0 : _response$data39.code) === 200)) {
            _context22.next = 9;
            break;
          }
          _context22.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.EDITORUNLOCK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context22.next = 11;
          break;
        case 9:
          _context22.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.EDITORUNLOCK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context22.next = 17;
          break;
        case 13:
          _context22.prev = 13;
          _context22.t0 = _context22["catch"](0);
          _context22.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.EDITORUNLOCK, _context22.t0));
        case 17:
        case "end":
          return _context22.stop();
      }
    }, _callee22, null, [[0, 13]]);
  })();
}

/**
 * unlock
 * @param payload
 * @returns api response
 * @description this function used to unlock.
 */
function siteUnlock(_ref23) {
  var payload = _ref23.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
    var _response$data40, response, _response$data41;
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.prev = 0;
          _context23.next = 3;
          return (0, _effects.call)(_services.siteUnlockApi, payload);
        case 3:
          response = _context23.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data40 = response.data) === null || _response$data40 === void 0 ? void 0 : _response$data40.code) === 202)) {
            _context23.next = 9;
            break;
          }
          _context23.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.UNLOCK, response.data.data));
        case 7:
          _context23.next = 11;
          break;
        case 9:
          _context23.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.UNLOCK, response === null || response === void 0 ? void 0 : (_response$data41 = response.data) === null || _response$data41 === void 0 ? void 0 : _response$data41.data));
        case 11:
          _context23.next = 17;
          break;
        case 13:
          _context23.prev = 13;
          _context23.t0 = _context23["catch"](0);
          _context23.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.UNLOCK, _context23.t0));
        case 17:
        case "end":
          return _context23.stop();
      }
    }, _callee23, null, [[0, 13]]);
  })();
}

/**
 * view snapshots
 * @param payload
 * @returns api response
 * @description this function used to view snapshots.
 */
function siteViewSnapshots(_ref24) {
  var payload = _ref24.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
    var _response$data42, response, _response$data43;
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.prev = 0;
          _context24.next = 3;
          return (0, _effects.call)(_services.siteViewSnapshotsApi, payload);
        case 3:
          response = _context24.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data42 = response.data) === null || _response$data42 === void 0 ? void 0 : _response$data42.code) === 202)) {
            _context24.next = 9;
            break;
          }
          _context24.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.VIEW_SNAPSHOTS, response.data.data));
        case 7:
          _context24.next = 11;
          break;
        case 9:
          _context24.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.VIEW_SNAPSHOTS, response === null || response === void 0 ? void 0 : (_response$data43 = response.data) === null || _response$data43 === void 0 ? void 0 : _response$data43.data));
        case 11:
          _context24.next = 17;
          break;
        case 13:
          _context24.prev = 13;
          _context24.t0 = _context24["catch"](0);
          _context24.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.VIEW_SNAPSHOTS, _context24.t0));
        case 17:
        case "end":
          return _context24.stop();
      }
    }, _callee24, null, [[0, 13]]);
  })();
}

/**
 * view editors
 * @param payload
 * @returns api response
 * @description this function used to view editors.
 */
function siteViewEditorList(_ref25) {
  var payload = _ref25.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
    var _response$data44, response, _response$data45;
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.prev = 0;
          _context25.next = 3;
          return (0, _effects.call)(_services.siteViewEditorListApi, payload);
        case 3:
          response = _context25.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data44 = response.data) === null || _response$data44 === void 0 ? void 0 : _response$data44.code) === 202)) {
            _context25.next = 9;
            break;
          }
          _context25.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.VIEW_EDITOR_LIST, response.data.data));
        case 7:
          _context25.next = 11;
          break;
        case 9:
          _context25.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.VIEW_EDITOR_LIST, response === null || response === void 0 ? void 0 : (_response$data45 = response.data) === null || _response$data45 === void 0 ? void 0 : _response$data45.data));
        case 11:
          _context25.next = 17;
          break;
        case 13:
          _context25.prev = 13;
          _context25.t0 = _context25["catch"](0);
          _context25.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.VIEW_EDITOR_LIST, _context25.t0));
        case 17:
        case "end":
          return _context25.stop();
      }
    }, _callee25, null, [[0, 13]]);
  })();
}

/**
 * view configs
 * @param payload
 * @returns api response
 * @description this function used to view configs.
 */
function siteViewConfig(_ref26) {
  var payload = _ref26.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
    var _response$data46, response, _response$data47;
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.prev = 0;
          _context26.next = 3;
          return (0, _effects.call)(_services.siteViewConfigApi, payload);
        case 3:
          response = _context26.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data46 = response.data) === null || _response$data46 === void 0 ? void 0 : _response$data46.code) === 202)) {
            _context26.next = 9;
            break;
          }
          _context26.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.VIEW_CONFIG, response.data.data));
        case 7:
          _context26.next = 11;
          break;
        case 9:
          _context26.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.VIEW_CONFIG, response === null || response === void 0 ? void 0 : (_response$data47 = response.data) === null || _response$data47 === void 0 ? void 0 : _response$data47.data));
        case 11:
          _context26.next = 17;
          break;
        case 13:
          _context26.prev = 13;
          _context26.t0 = _context26["catch"](0);
          _context26.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.VIEW_CONFIG, _context26.t0));
        case 17:
        case "end":
          return _context26.stop();
      }
    }, _callee26, null, [[0, 13]]);
  })();
}

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete.
 */
function siteSoftDelete(_ref27) {
  var payload = _ref27.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
    var _response$data48, response, _response$data49;
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.prev = 0;
          _context27.next = 3;
          return (0, _effects.call)(_services.siteSoftDeleteApi, payload);
        case 3:
          response = _context27.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data48 = response.data) === null || _response$data48 === void 0 ? void 0 : _response$data48.code) === 202)) {
            _context27.next = 9;
            break;
          }
          _context27.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.SOFT_DELETE, response.data.data));
        case 7:
          _context27.next = 11;
          break;
        case 9:
          _context27.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.SOFT_DELETE, response === null || response === void 0 ? void 0 : (_response$data49 = response.data) === null || _response$data49 === void 0 ? void 0 : _response$data49.data));
        case 11:
          _context27.next = 17;
          break;
        case 13:
          _context27.prev = 13;
          _context27.t0 = _context27["catch"](0);
          _context27.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.SOFT_DELETE, _context27.t0));
        case 17:
        case "end":
          return _context27.stop();
      }
    }, _callee27, null, [[0, 13]]);
  })();
}

/**
 * soft delete list
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete list.
 */
function siteSoftDeleteList(_ref28) {
  var payload = _ref28.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
    var _payload25, _payload25$fkUserIdLi, _payload26, _payload26$fkUserIdLi, _payload27, _payload28, _payload29, _payload29$fkDeletedB, _payload30, _payload30$fkDeletedB, _payload31, _payload32, _payload33, _payload34, _payload35, _payload36, _payload36$yearList, _payload37, _payload37$yearList, _payload38, _payload38$tags, _response$data50, filter, _payload39, _payload39$tags, colTags, response, _response$data51, _response$data52;
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.prev = 0;
          filter = {}; // Owner
          if ((_payload25 = payload) !== null && _payload25 !== void 0 && (_payload25$fkUserIdLi = _payload25.fkUserIdList) !== null && _payload25$fkUserIdLi !== void 0 && _payload25$fkUserIdLi.value) filter["fkUserIdList"] = (_payload26 = payload) === null || _payload26 === void 0 ? void 0 : (_payload26$fkUserIdLi = _payload26.fkUserIdList) === null || _payload26$fkUserIdLi === void 0 ? void 0 : _payload26$fkUserIdLi.value;else if (Array.isArray((_payload27 = payload) === null || _payload27 === void 0 ? void 0 : _payload27.fkUserIdList)) filter["fkUserIdList"] = (_payload28 = payload) === null || _payload28 === void 0 ? void 0 : _payload28.fkUserIdList;
          if ((_payload29 = payload) !== null && _payload29 !== void 0 && (_payload29$fkDeletedB = _payload29.fkDeletedByList) !== null && _payload29$fkDeletedB !== void 0 && _payload29$fkDeletedB.value) filter["fkDeletedByList"] = (_payload30 = payload) === null || _payload30 === void 0 ? void 0 : (_payload30$fkDeletedB = _payload30.fkDeletedByList) === null || _payload30$fkDeletedB === void 0 ? void 0 : _payload30$fkDeletedB.value;else if (Array.isArray((_payload31 = payload) === null || _payload31 === void 0 ? void 0 : _payload31.fkDeletedByList)) filter["fkDeletedByList"] = (_payload32 = payload) === null || _payload32 === void 0 ? void 0 : _payload32.fkDeletedByList;
          if (((_payload33 = payload) === null || _payload33 === void 0 ? void 0 : _payload33.dateRange) === "date" && (_payload34 = payload) !== null && _payload34 !== void 0 && _payload34.from && (_payload35 = payload) !== null && _payload35 !== void 0 && _payload35.to) {
            filter["startDate"] = payload.from;
            filter["endDate"] = payload.to;
          }

          // Year
          if ((_payload36 = payload) !== null && _payload36 !== void 0 && (_payload36$yearList = _payload36.yearList) !== null && _payload36$yearList !== void 0 && _payload36$yearList.value) filter["colFiscalYear"] = (_payload37 = payload) === null || _payload37 === void 0 ? void 0 : (_payload37$yearList = _payload37.yearList) === null || _payload37$yearList === void 0 ? void 0 : _payload37$yearList.value;
          if (((_payload38 = payload) === null || _payload38 === void 0 ? void 0 : (_payload38$tags = _payload38.tags) === null || _payload38$tags === void 0 ? void 0 : _payload38$tags.length) > 0) {
            colTags = "";
            (_payload39 = payload) === null || _payload39 === void 0 ? void 0 : (_payload39$tags = _payload39.tags) === null || _payload39$tags === void 0 ? void 0 : _payload39$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          delete payload.fkUserIdList;
          delete payload.yearList;
          delete payload.fkDeletedByList;
          delete payload.colTags;
          delete payload.from;
          delete payload.to;
          delete payload.tags;
          delete payload.dateRange;
          delete payload.startDate;
          delete payload.endDate;
          payload = _objectSpread(_objectSpread({}, payload), filter);
          _context28.next = 20;
          return (0, _effects.call)(_services.siteSoftDeleteListApi, payload);
        case 20:
          response = _context28.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data50 = response.data) === null || _response$data50 === void 0 ? void 0 : _response$data50.code) === 202)) {
            _context28.next = 26;
            break;
          }
          _context28.next = 24;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.SOFT_DELETE_LIST, response === null || response === void 0 ? void 0 : (_response$data51 = response.data) === null || _response$data51 === void 0 ? void 0 : _response$data51.data));
        case 24:
          _context28.next = 28;
          break;
        case 26:
          _context28.next = 28;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.SOFT_DELETE_LIST, response === null || response === void 0 ? void 0 : (_response$data52 = response.data) === null || _response$data52 === void 0 ? void 0 : _response$data52.data));
        case 28:
          _context28.next = 34;
          break;
        case 30:
          _context28.prev = 30;
          _context28.t0 = _context28["catch"](0);
          _context28.next = 34;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.SOFT_DELETE_LIST, _context28.t0));
        case 34:
        case "end":
          return _context28.stop();
      }
    }, _callee28, null, [[0, 30]]);
  })();
}

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete restore.
 */
function siteSoftDeleteRestore(_ref29) {
  var payload = _ref29.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
    var _response$data53, response, _response$data54;
    return _regeneratorRuntime().wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.prev = 0;
          _context29.next = 3;
          return (0, _effects.call)(_services.siteSoftDeleteRestoreApi, payload);
        case 3:
          response = _context29.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data53 = response.data) === null || _response$data53 === void 0 ? void 0 : _response$data53.code) === 202)) {
            _context29.next = 9;
            break;
          }
          _context29.next = 7;
          return (0, _effects.put)((0, _site.siteSuccess)(_site2.actionTypes.SOFT_DELETE_RESTORE, response.data.data));
        case 7:
          _context29.next = 11;
          break;
        case 9:
          _context29.next = 11;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.SOFT_DELETE_RESTORE, response === null || response === void 0 ? void 0 : (_response$data54 = response.data) === null || _response$data54 === void 0 ? void 0 : _response$data54.data));
        case 11:
          _context29.next = 17;
          break;
        case 13:
          _context29.prev = 13;
          _context29.t0 = _context29["catch"](0);
          _context29.next = 17;
          return (0, _effects.put)((0, _site.siteError)(_site2.actionTypes.SOFT_DELETE_RESTORE, _context29.t0));
        case 17:
        case "end":
          return _context29.stop();
      }
    }, _callee29, null, [[0, 13]]);
  })();
}
var watchSite = function watchSite() {
  return /*#__PURE__*/_regeneratorRuntime().mark(function watch() {
    return _regeneratorRuntime().wrap(function watch$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          _context30.next = 2;
          return (0, _effects.takeLatest)(_site2.actionTypes.ADD, siteAdd);
        case 2:
          _context30.next = 4;
          return (0, _effects.takeLatest)(_site2.actionTypes.EDIT_SAVE, siteEditSave);
        case 4:
          _context30.next = 6;
          return (0, _effects.takeLatest)(_site2.actionTypes.EDIT, siteEdit);
        case 6:
          _context30.next = 8;
          return (0, _effects.takeLatest)(_site2.actionTypes.READ, siteRead);
        case 8:
          _context30.next = 10;
          return (0, _effects.takeLatest)(_site2.actionTypes.CHANGE, siteChange);
        case 10:
          _context30.next = 12;
          return (0, _effects.takeLatest)(_site2.actionTypes.UPDATE, siteUpdate);
        case 12:
          _context30.next = 14;
          return (0, _effects.takeLatest)(_site2.actionTypes.LIST, siteList);
        case 14:
          _context30.next = 16;
          return (0, _effects.takeLatest)(_site2.actionTypes.LIST_REVIEW_APPROVAL, siteListReviewAndApproval);
        case 16:
          _context30.next = 18;
          return (0, _effects.takeLatest)(_site2.actionTypes.SUBMIT, siteSubmit);
        case 18:
          _context30.next = 20;
          return (0, _effects.takeLatest)(_site2.actionTypes.APPROVE, siteApprove);
        case 20:
          _context30.next = 22;
          return (0, _effects.takeLatest)(_site2.actionTypes.DELETE, siteDelete);
        case 22:
          _context30.next = 24;
          return (0, _effects.takeLatest)(_site2.actionTypes.CLONE, siteClone);
        case 24:
          _context30.next = 26;
          return (0, _effects.takeLatest)(_site2.actionTypes.SAVE, siteSave);
        case 26:
          _context30.next = 28;
          return (0, _effects.takeLatest)(_site2.actionTypes.BUILD_LIST, siteBuildList);
        case 28:
          _context30.next = 30;
          return (0, _effects.takeLatest)(_site2.actionTypes.FILTER, siteFilter);
        case 30:
          _context30.next = 32;
          return (0, _effects.takeLatest)(_site2.actionTypes.PAUSE, sitePause);
        case 32:
          _context30.next = 34;
          return (0, _effects.takeLatest)(_site2.actionTypes.PLAY, sitePlay);
        case 34:
          _context30.next = 36;
          return (0, _effects.takeLatest)(_site2.actionTypes.COPY_URL, siteCopyUrl);
        case 36:
          _context30.next = 38;
          return (0, _effects.takeLatest)(_site2.actionTypes.DOWNLOAD_EMAIL, siteDownloadUrl);
        case 38:
          _context30.next = 40;
          return (0, _effects.takeLatest)(_site2.actionTypes.LOCK, siteLock);
        case 40:
          _context30.next = 42;
          return (0, _effects.takeLatest)(_site2.actionTypes.UNLOCK, siteUnlock);
        case 42:
          _context30.next = 44;
          return (0, _effects.takeLatest)(_site2.actionTypes.EDITORLOCK, siteEditorLock);
        case 44:
          _context30.next = 46;
          return (0, _effects.takeLatest)(_site2.actionTypes.EDITORUNLOCK, siteEditorUnlock);
        case 46:
          _context30.next = 48;
          return (0, _effects.takeLatest)(_site2.actionTypes.VIEW_SNAPSHOTS, siteViewSnapshots);
        case 48:
          _context30.next = 50;
          return (0, _effects.takeLatest)(_site2.actionTypes.VIEW_EDITOR_LIST, siteViewEditorList);
        case 50:
          _context30.next = 52;
          return (0, _effects.takeLatest)(_site2.actionTypes.VIEW_CONFIG, siteViewConfig);
        case 52:
          _context30.next = 54;
          return (0, _effects.takeLatest)(_site2.actionTypes.SOFT_DELETE, siteSoftDelete);
        case 54:
          _context30.next = 56;
          return (0, _effects.takeLatest)(_site2.actionTypes.SOFT_DELETE_LIST, siteSoftDeleteList);
        case 56:
          _context30.next = 58;
          return (0, _effects.takeLatest)(_site2.actionTypes.SOFT_DELETE_RESTORE, siteSoftDeleteRestore);
        case 58:
        case "end":
          return _context30.stop();
      }
    }, watch);
  });
};
function siteSaga() {
  return _regeneratorRuntime().wrap(function siteSaga$(_context31) {
    while (1) switch (_context31.prev = _context31.next) {
      case 0:
        _context31.next = 2;
        return (0, _effects.all)([(0, _effects.fork)(watchSite())]);
      case 2:
      case "end":
        return _context31.stop();
    }
  }, _marked);
}